import React, { createContext, useContext, useMemo } from 'react';
import type { ProviderInterface } from './types';
import { MockProvider } from './mock';
import { SupabaseProvider } from './supabase';

const ProviderContext = createContext<ProviderInterface | null>(null);

export const ProviderType = import.meta.env.VITE_PROVIDER_TYPE || 'mock';

export const DataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const provider = useMemo(() => {
        if (ProviderType === 'supabase') {
            const url = import.meta.env.VITE_SUPABASE_URL;
            const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
            if (!url || !key) {
                console.warn('Supabase credentials missing, falling back to mock');
                return new MockProvider();
            }
            return new SupabaseProvider(url, key);
        }
        return new MockProvider();
    }, []);

    return (
        <ProviderContext.Provider value={provider}>
            {children}
        </ProviderContext.Provider>
    );
};

export const useProvider = () => {
    const context = useContext(ProviderContext);
    if (!context) {
        throw new Error('useProvider must be used within a DataProvider');
    }
    return context;
};
